(function(){
    'use strict';
    
    jcu_js_v1.fn.initTestimonial = function() {
        /******* testimonials carousel with lazyload *********/
        if ($('#testimonial-carousel').length > 0) {
          var lazyBgImg = function lazyBgImg(el) {
            var lazyBgImgs = $(el).find('.testimonial-bg-img.lazy-bg-img'); //console.log(lazyBgImgs);
    
            lazyBgImgs.each(function (i) {
              var el = $(this); //console.log(el);
    
              if (!el.hasClass('is-lazy-loaded')) {
                el.addClass('is-lazy-loaded');
              }
            });
          };
    
          var s = $('#testimonial-carousel').on('init', function (event, slick) {
            //console.log("#testimonial-carousel slick init!");
            var nextOne = slick.currentSlide + 1;
    
            if (slick.currentSlide !== nextOne) {
              //console.log(slick.currentSlide + ' = ' + nextOne);
              lazyBgImg($(slick.$slides.get(nextOne)));
            }
          });
          s.slick({
            lazyLoad: 'ondemand',
            dots: false,
            arrows: true,
            speed: 700,
            slidesToScroll: 1,
            slidesToShow: 1,
            autoplay: false,
            autoplaySpeed: 10000,
            draggable: true,
            swipeToSlide: true
          });
          s.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (currentSlide !== nextSlide) {
              var more = nextSlide + 1; //console.log(currentSlide + ' = ' + nextSlide + ' = ' + more)
    
              lazyBgImg($(slick.$slides.get(nextSlide)));
              lazyBgImg($(slick.$slides.get(more)));
            }
          });
        }
    }
    
    jcu_js_v1.fn.initTestimonial();

}());